module.exports = __webpack_public_path__ + "img/dagou.c831ea08.png";